import { FiChevronDown } from "react-icons/fi";
import { forwardRef } from "react";

const ScrollableDropdown = forwardRef(
  (
    {
      label,
      options,
      value,
      onChange,
      isOpen,
      onToggle,
      disabled = false,
      className = "",
      dropdownHeight = "max-h-[28vh]",
      ...rest
    },
    ref
  ) => {
    const handleSelect = (val) => {
      if (disabled) return;
      onChange(val);
      if (onToggle) onToggle(false); // close dropdown after selection
    };

    return (
      <div
        ref={ref}
        className={`relative ${
          disabled ? "opacity-60 cursor-not-allowed" : ""
        }`}
      >
        {/* Dropdown button */}
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            if (!disabled && onToggle) onToggle(!isOpen);
          }}
          className={`w-full text-left px-4 py-2 border rounded-md text-xs text-gray-800 md:text-sm font-normal flex justify-between items-center ${
            disabled
              ? "bg-gray-200 border-gray-400 cursor-not-allowed"
              : isOpen
              ? "border-blue-500"
              : "hover:border-gray-400"
          } focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 ${className}`}
          {...rest}
        >
          {/* Display selected value or placeholder label */}
          {options.find((opt) => opt.value === value)?.label ?? label}

          {/* Arrow icon */}
          <FiChevronDown
            className={`w-5 h-5 ml-2 transform transition-transform duration-100 ${
              isOpen ? "rotate-180" : "rotate-0"
            }`}
          />
        </button>

        {/* Dropdown list */}
        {!disabled && (
          <div
            className={`absolute z-50 mt-2 min-w-full md:w-48 bg-white divide-y divide-gray-100 rounded-lg shadow transition-all duration-200 origin-top ${
              isOpen
                ? "opacity-100 scale-100 pointer-events-auto"
                : "opacity-0 scale-95 pointer-events-none"
            } ${dropdownHeight} overflow-auto`}
          >
            <ul className="py-2 text-xs md:text-sm text-gray-700">
              {options.map((opt) => (
                <li key={opt.value}>
                  <button
                    type="button"
                    disabled={disabled}
                    className={`w-full px-4 py-2 text-left hover:bg-gray-100 ${
                      value === opt.value ? "bg-gray-100 font-normal" : ""
                    }`}
                    onClick={() => handleSelect(opt.value)}
                  >
                    {opt.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }
);

export default ScrollableDropdown;
